export default {
  CREDIT_CARD: 'CREDIT_CARD',
  APPLE_PAY: 'APPLE_PAY',
  WEB_PAY: 'WEB_PAY',
}



// WEBPACK FOOTER //
// ./src/constants/paymentTypes.js